"use client";
import {
  Image_default
} from "./chunk-BVJ4WRGT.mjs";
import {
  Button_default
} from "./chunk-CGHW2YLJ.mjs";

// src/components/sections/StepwiseImages/StepwiseImages.tsx
import { forwardRef, useState } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var StepwiseImages = forwardRef(
  function StepwiseImages2({ referId, tag, title, features, buttons }, ref) {
    var _a, _b, _c, _d, _e, _f;
    const [currentListCard, setCurrentListCard] = useState(
      features[0]
    );
    return /* @__PURE__ */ jsxs(
      "div",
      {
        id: referId,
        ref,
        className: "flex flex-col justify-center md:justify-start items-center py-40 lg:py-80 md:px-24 mx-auto max-w-[455px] md:max-w-[1108px]",
        children: [
          /* @__PURE__ */ jsxs("div", { className: "flex relative lg:gap-40 justify-center lg:justify-start items-start mx-auto md:mx-24 lg:mx-0 md:w-full max-w-[455px] md:max-w-full", children: [
            /* @__PURE__ */ jsxs("div", { className: "w-full md:max-w-[510px]", children: [
              /* @__PURE__ */ jsxs("div", { className: "flex flex-col md:justify-center px-16 lg:px-0 w-full md:text-center lg:text-left", children: [
                tag && /* @__PURE__ */ jsx(
                  "p",
                  {
                    className: "mb-8 md:mb-16 w-full max-w-[455px] md:max-w-full font-sans text-sm font-bold leading-3 text-stone-700 uppercase",
                    dangerouslySetInnerHTML: {
                      __html: tag
                    }
                  }
                ),
                /* @__PURE__ */ jsx(
                  "h2",
                  {
                    className: "mb-16 w-full max-w-[510px] font-display text-3xl md:text-4xl lg:text-[32px] font-bold leading-7 md:leading-8 lg:leading-[40px]",
                    dangerouslySetInnerHTML: {
                      __html: title
                    }
                  }
                )
              ] }),
              /* @__PURE__ */ jsx("div", { className: "min-h-[320px]", children: features.map((card, index) => {
                var _a2;
                const isActive = currentListCard === card;
                return /* @__PURE__ */ jsxs(
                  "div",
                  {
                    "data-card-name": "listWrapper",
                    "data-card-index": `listWrapper-${index}`,
                    className: `relative ${index === 0 ? "w-full smd:max-w-[510px]" : ""} overflow-hidden first:rounded-t-[8px] last:rounded-b-[8px] md:rounded-none ${isActive ? "z-0 overflow-unset" : ""}`,
                    children: [
                      /* @__PURE__ */ jsx(
                        "div",
                        {
                          className: `${isActive ? "flex" : "hidden"} w-full overflow-hidden justify-center md:hidden h-[320px] rounded-t-[24px] border-t-[1px] border-display-400 md:!rounded-none`,
                          children: /* @__PURE__ */ jsx("div", { className: "flex justify-center pt-24 mx-24 w-full bg-display-200", children: /* @__PURE__ */ jsx(
                            Image_default,
                            {
                              src: card == null ? void 0 : card.image.path,
                              width: 312,
                              height: 436,
                              alt: (_a2 = card == null ? void 0 : card.image) == null ? void 0 : _a2.alternativeText,
                              className: "object-cover object-center"
                            }
                          ) })
                        }
                      ),
                      /* @__PURE__ */ jsxs(
                        "div",
                        {
                          onClick: () => setCurrentListCard(card),
                          className: `relative min-h-[84px] p-16 mx-24 md:mr-40 md:ml-12 lg:mx-16 border-l-[1px] border-r-[1px] border-t-[1px] cursor-pointer border-display-400 ${isActive ? "bg-stone-500 !rounded-[8px] mx-16 md:mx-24 md:ml-0 lg:!mx-0 !border-t-0" : "bg-display-0 border-b-[1px] !rounded-none"}
              `,
                          children: [
                            /* @__PURE__ */ jsx(
                              "p",
                              {
                                className: `mb-4 text-[16px] font-bold leading-[24px] ${isActive ? "text-display-0" : "text-display-900"}`,
                                dangerouslySetInnerHTML: { __html: card == null ? void 0 : card.title }
                              }
                            ),
                            /* @__PURE__ */ jsx(
                              "p",
                              {
                                className: `font-normal text-[16px] leading-[24px] paragraph-16 
                  ${isActive ? "text-display-0" : "text-display-900"}
                `,
                                dangerouslySetInnerHTML: { __html: card == null ? void 0 : card.description }
                              }
                            )
                          ]
                        }
                      )
                    ]
                  },
                  `listItem-item--${index}`
                );
              }) }),
              /* @__PURE__ */ jsx("div", { className: "hidden lg:flex gap-24 justify-start px-0 mx-auto mt-24 w-full", children: buttons == null ? void 0 : buttons.map((props, index) => /* @__PURE__ */ jsx(
                Button_default,
                {
                  className: "w-full md:w-max",
                  ...props
                },
                `${props.label}-${index}`
              )) })
            ] }),
            /* @__PURE__ */ jsx(
              "div",
              {
                id: "listImageContainer",
                className: "hidden md:flex justify-center p-16 w-full max-w-[510px] h-[582px] bg-display-200 rounded-[24px]",
                children: /* @__PURE__ */ jsx(
                  Image_default,
                  {
                    src: ((_a = currentListCard == null ? void 0 : currentListCard.image) == null ? void 0 : _a.path) ? (_b = currentListCard == null ? void 0 : currentListCard.image) == null ? void 0 : _b.path : (_d = (_c = features[0]) == null ? void 0 : _c.image) == null ? void 0 : _d.path,
                    width: 345,
                    height: 516,
                    alt: (_f = (_e = features[0]) == null ? void 0 : _e.image) == null ? void 0 : _f.alternativeText,
                    className: "object-contain w-full h-full"
                  }
                )
              }
            )
          ] }),
          /* @__PURE__ */ jsx("div", { className: "flex lg:hidden gap-24 justify-center px-24 mx-auto mt-24 w-full", children: buttons == null ? void 0 : buttons.map((props, index) => /* @__PURE__ */ jsx(
            Button_default,
            {
              className: "w-full md:w-max",
              ...props
            },
            `${props.label}-${index}`
          )) })
        ]
      }
    );
  }
);
var StepwiseImages_default = StepwiseImages;

export {
  StepwiseImages_default
};
